import { API } from 'aws-amplify';

import * as actionTypes from './actionTypes';

const basePath = '/users';
const apiName = 'users';
const actions = {
  listUsers: async ({ commit }, payload) => {
    commit(actionTypes.LIST_USERS_START);
    let path = `${basePath}?organization=${payload}`;
    try {
      const res = await API.get(apiName, path, {});
      console.log('List Users res: ', res);
      commit(actionTypes.LIST_USERS_SUCCESS, res);
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.LIST_USERS_FAIL, errorMsg);
    }
  },
  createUser: async ({ commit }, payload) => {
    commit(actionTypes.CREATE_USER_START);
    const { vm, user, cb } = payload;
    const opts = {
      body: user,
    };
    try {
      const res = await API.post(apiName, basePath, opts);
      console.log('CREATE USER - res: ', res);
      commit(actionTypes.CREATE_USER_SUCCESS, res);
      vm.$store.dispatch('listUsers', user.organization);
      vm.$bvToast.toast(`${user.name} was created successfully!`, {
        autoHideDelay: 5000,
        appendToast: true,
        toaster: 'b-toaster-top-center',
        headerClass: 'b-toaster-no-line'
      });

      if (cb) cb();
    } catch (err) {
      console.log('Create User Error: ', err.response);
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.CREATE_USER_FAIL, errorMsg);
    }
  },
  updateUser: async ({ commit }, payload) => {
    commit(actionTypes.UPDATE_USER_START);
    const { vm, user } = payload;
    const opts = {
      body: {
        isEnabled: user.isEnabled,
      },
    };
    const path = `${basePath}/${user.user.username}`;
    try {
      const res = await API.put(apiName, path, opts);
      console.log('Update USER - res: ', res);
      commit(actionTypes.UPDATE_USER_SUCCESS, res);
      vm.$store.dispatch('listUsers', user.user.organization)
    } catch (err) {
      const errorMsg = err && err.response && err.response.data && err.response.data.error ? err.response.data.error : 'Please try again.';
      commit(actionTypes.UPDATE_USER_FAIL, errorMsg);
    }
  },
  deleteUser: async ({ commit }, payload) => {
    commit(actionTypes.DELETE_USER_START);
    const { vm, user } = payload;
    const path = `${basePath}/${user.sub}`;
    const opts = {};
    try {
      const res = await API.del(apiName, path, opts);
      console.log('Delete User  - res: ', res);
      commit(actionTypes.DELETE_USER_SUCCESS, res);
      vm.$store.dispatch('listUsers', user.organization);
    } catch (err) {
      commit(actionTypes.DELETE_USER_FAIL, err);
    }
  },
  setUserToUpdate: ({ commit }, payload) => {
    console.log('---- set user to update ----');
    console.log(payload);
    commit(actionTypes.SET_USER_TO_UPDATE, payload);
  },
  setUserToDelete: ({ commit }, payload) => {
    console.log('---- set user to delete ----');
    console.log(payload);
    commit(actionTypes.SET_USER_TO_DELETE, payload);
  },
  clearUserState: ({ commit }) => {
    commit(actionTypes.CLEAR_USER_UPDATE_STATE);
  }
};

export default actions;
